import React, { Fragment } from 'react';
import { translate } from '../Services/translation';
import DynamicComponent from './DynamicComponent';
//import ReactElement from '../Containers/Campaign.container';

const Navigation = ({ links = [], contentLink = null }) => {
    let menuRef = React.createRef();
    function toggleMenu() {
        menuRef.current.classList.toggle('navbar__menu--show');
    }
    let additionClass = contentLink && contentLink.attributes ? contentLink.attributes.cssValue : '';
    let hasChildrenClass = links.length > 0 ? 'has-children' : null;
    let hiddenClasses = "";

    if (contentLink) { 
        if (contentLink.hideForMobile || contentLink.hideForTablet || contentLink.hideForDesktop) {
            
            if (!contentLink.hideForMobile && !contentLink.hideForTablet) {
                hiddenClasses = " hide-for-large";
            }
            else if (!contentLink.hideForMobile && !contentLink.hideForDesktop) {
                hiddenClasses = " hide-for-medium-only";
            }
            else if (!contentLink.hideForTablet && !contentLink.hideForDesktop) {
                hiddenClasses = " hide-for-small-only";
            }
            else if (contentLink.hideForMobile && contentLink.hideForTablet && !contentLink.hideForDesktop) {
                hiddenClasses = " show-for-large";
            }
            else if (contentLink.hideForMobile && contentLink.hideForTablet && !contentLink.hideForDesktop) {
                hiddenClasses = " show-for-large";
            }
            else if (contentLink.hideForMobile && !contentLink.hideForTablet && !contentLink.hideForDesktop) {
                hiddenClasses = " show-for-medium";
            }
            else if (contentLink.hideForMobile && contentLink.hideForTablet && contentLink.hideForDesktop) {
                hiddenClasses = " hide";
            }
            else if (contentLink.hideForMobile) {
                hiddenClasses = " hide-for-small";
            }
            else if (contentLink.hideForTablet) {
                hiddenClasses = " hide-for-medium";
            }
            else if (contentLink.hideForDesktop) {
                hiddenClasses = " hide-for-desktop";
            }
        }
        additionClass += " " + hiddenClasses;
    }

    // *************************************************************
    // IS ReactPage 
    // *************************************************************
    let contentLinkName = "";
    let reactElementClass = "";
    if (contentLink) {
        reactElementClass = contentLink.reactElementClass;
        contentLinkName = contentLink.name;
        let campaignCount = 0;
        
        if (reactElementClass && (reactElementClass === 'Campaign' || reactElementClass === 'CampaignFocus')) {
            campaignCount = contentLink.campaignCount;
            contentLinkName += '<span class="campaign-badge">(' + campaignCount + ')</span>';
        }
    }
    if ((contentLink && contentLink.reactPageHasMegaMenu)) {
        let ReactElement = null;
        let menuClass = "";
        
        // *************************************************************
        // ReactElement has to be set with static string not variable!
        // *************************************************************
        switch (reactElementClass) {
            case 'Campaign':
                ReactElement = DynamicComponent({
                    loader: () => import('../Containers/Campaign.container')
                });
                menuClass += " full-width-list campaign";
                additionClass += " has-children";
                
                break;
            case 'CampaignFocus':
                ReactElement = DynamicComponent({
                    loader: () => import('../Containers/CampaignFocus.container')
                });
                menuClass += " full-width-list campaign";
                additionClass += " has-children";

                break;
            case 'QuickOrder':
                //ReactElement = DynamicComponent({
                //    loader: () => import('../Containers/Campaign.container')
                //});
                break;
            case 'ArticleEditor':
                //ReactElement = DynamicComponent({
                //    loader: () => import('../Containers/Campaign.container')
                //});
                break;
            default: break;
        }

        hasChildrenClass = ReactElement ? 'has-children' : null;
        return (
            <Fragment>
                <Fragment>
                    <a className={`navbar__link || ''} ${additionClass || ''}`}
                        href={contentLink.url || '#'} dangerouslySetInnerHTML={{ __html: contentLinkName }} >
                    </a>
                    <i className="navbar__icon--caret-right navbar__icon navbar__icon--open" onClick={toggleMenu}></i>
                    {ReactElement &&
                        <div className={`navbar__menu ${menuClass}`} ref={menuRef}><ul><li><ReactElement url={contentLink.url || '#'} hasMegaMenu={true} /></li></ul></div>
                    }
                </Fragment>
            </Fragment>
        )
    }
    else {
        
        return (
            <Fragment>
                {!contentLink ? (
                    <a className="navbar__link--block navbar__icon--menu navbar__icon" onClick={toggleMenu}><label>{translate('common.mobile.menu')}</label></a>
                ) : (
                        <Fragment>
                            <a className={`navbar__link ${hasChildrenClass || ''} ${additionClass || ''}`}
                                href={contentLink.url || '#'} dangerouslySetInnerHTML={{ __html: contentLinkName }} >
                            </a>
                            {links.length > 0 &&
                                <i className="navbar__icon--caret-right navbar__icon navbar__icon--open" onClick={toggleMenu}></i>
                            }
                        </Fragment>
                    )}

                {links.length > 0 &&
                    <div className="navbar__menu" ref={menuRef} test={links.length}>
                        <ul>
                            <li className="navbar__menu-header">
                                <div>
                                    {!contentLink ? (
                                        <span className="navbar__icon navbar__icon--close" onClick={toggleMenu}><label>{translate('common.mobile.close')}</label></span>
                                    ) : (
                                            <Fragment>
                                                <i className="navbar__icon--caret-left navbar__icon" onClick={toggleMenu}></i>
                                                <span className="navbar__title" onClick={toggleMenu} dangerouslySetInnerHTML={{ __html: contentLink.name }}></span>
                                            </Fragment>
                                        )}
                                </div>
                            </li>
                            {!contentLink &&
                                <li className="navbar__item flags"> <div id="websiteSelector"></div></li>
                            }
                            {links.length > 0 && links.map((link, i) => !link.name ? null :
                                <li className="navbar__item" key={`${link.name}-${i}`}>
                                    <Navigation links={link.links} contentLink={link} />
                                </li>
                            )}
                        </ul>
                    </div>
                }

            </Fragment>
        )
    }
}

export default Navigation;